export interface SelectTimeFrameProps {
    selectedTimeFrame?: {
        to?: Date;
        from?: Date;
        timeFrame?: TimeFrame;
    };
    onSelectTimeFrame: Function;
    limitUntil?: Date;
    selectTimeFrameRef?: any;
}

export enum TimeFrame {
    TODAY = 'Today',
    PAST_WEEK = 'PastWeek',
    PAST_MONTH = 'PastMonth',
    PAST_YEAR = 'PastYear',
    CUSTOM = 'Custom'
}
